export enum ErrorType {
  EXPIRE = "expire",
  UNKNOWN = "unknown",
  FAILURE = "failure",
}

export interface Error {
  type: ErrorType;
  title: string;
  message: string;
}
